module.exports = __webpack_public_path__ + "img/mile6m-m@1.d7190322.webp";